module.exports = __webpack_public_path__ + "img/market.cb3db200.svg";